var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNews = function SvgNews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 29,
    fill: "none",
    viewBox: "0 0 30 29"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 30,
    height: 29,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 0H0v29h30z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.018 26.692H7.516A2.52 2.52 0 0 1 5 24.177V5.515A2.52 2.52 0 0 1 7.516 3h15.502a2.52 2.52 0 0 1 2.516 2.516v18.66a2.52 2.52 0 0 1-2.516 2.516M7.516 4.58a.94.94 0 0 0-.937.937v18.66a.94.94 0 0 0 .937.937h15.502a.94.94 0 0 0 .936-.936V5.515a.94.94 0 0 0-.936-.937z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.267 12.477H9.739a.791.791 0 1 1 0-1.58h5.528a.79.79 0 1 1 0 1.58M20.79 8.528H9.74a.79.79 0 1 1 0-1.58H20.79a.79.79 0 1 1 0 1.58"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v29H0z"
  })))));
};
export default SvgNews;